import tw, { styled } from 'twin.macro';
import { StyledLogo } from './components/FooterLogo/FooterLogo.styles';
import Link from '@/components/Link/Link';

export const StyledGrid = styled.div`
  ${tw`flex flex-col gap-[52px] lg:flex-row lg:gap-4`}
  ${tw`w-full`}
`;

export const StyledCopyrightText = styled.div`
  ${tw`font-inter font-regular`}
  ${tw`text-primary-p1 text-center lg:text-left text-mobile-body-s`}
  ${tw`lg:max-w-[500px]`}
  ${tw`lg:order-first`}
`;

export const StyledFooter = styled.footer<{
  minified: boolean;
}>`
  ${tw`bg-ui-colours-ui1`}
  ${tw`pt-[28px] pb-[134px] lg:pt-[104px] lg:pb-6 md:px-3`}
  ${tw`mt-auto`}
  ${tw`border-t-2 border-ui-colours-ui3`}

  ${({ minified }) => minified && tw`pb-5 lg:pt-[71px] lg:pb-[65px]`}

  ${StyledLogo} {
    ${({ minified }) => minified && tw`lg:w-[147px]`}
  }

  ${StyledGrid} {
    ${({ minified }) => minified && tw`gap-[18px] lg:flex-col`}
  }

  ${StyledCopyrightText} {
    ${({ minified }) => minified && tw`text-left`}
  }
`;

export const StyledContainer = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`relative`}
  ${tw`px-2 md:px-0`}
`;

export const StyledGridContent = styled.div`
  ${tw`lg:grow`}
`;

export const StyledFootnotesGrid = styled.div`
  ${tw`lg:flex lg:justify-between`}
`;

export const StyledListColumns = styled.ul`
  ${tw`list-none`}
  ${tw`m-0 mb-2 lg:mb-4 lg:mb-[44px] last:mb-0`}
  ${tw`lg:grid lg:grid-cols-5 lg:gap-4`}
  ${tw`lg:break-inside-avoid`}
  ${tw`sm:columns-1 md:columns-2`}
`;

export const StyledIconSection = styled.div`
  ${tw`flex flex-col lg:flex-row flex-wrap gap-2 justify-end `}
  ${tw`lg:border-b lg:border-solid lg:border-ui-colours-ui3`}
  ${tw`pb-4`}
  ${tw`lg:mb-4`}
`;

export const StyledPrivacyLinkList = styled.ul`
  ${tw`list-none`}
  ${tw`text-center`}
  ${tw`lg:flex flex-wrap`}

  & a,button {
    ${tw`text-body-xs`}
  }
`;

export const StyledListItemPrivacy = styled.li`
  ${tw`whitespace-nowrap`}
  ${tw`lg:not-last:border-r not-last:border-primary-p1`}
  ${tw`lg:not-last:pr-1 lg:not-last:mr-1`}
`;

export const StyledListSocialNetwork = styled.ul`
  ${tw`list-none`}
  ${tw`p-0 m-0`}
  ${tw`lg:relative lg:-mt-1`}
  ${tw`flex flex-wrap gap-2 justify-center lg:justify-end lg:items-center`}
`;

export const StyledCertificationLogoList = styled.ul`
  ${tw`flex gap-2`}
  ${tw`justify-center lg:justify-end`}
`;

export const StyledPrivacyAndCertificationGrid = styled.div`
  ${tw`lg:flex lg:justify-between lg:gap-8`}
  ${tw`mb-4`}
`;

export const StyledLink = styled(Link)`
  ${tw`font-regular font-inter`}
  ${tw`text-body-s text-primary-p1`}
  ${tw`inline`}
  ${tw`tracking-normal`}
  ${tw`hover:underline`}
`;
